(function ($) {
    $(function () {
        // Check if the modal has been shown before
        if (getCookie('law25_modal_shown') !== '1') {
            $('#modalLoi25').show();

            $('#modal__close').on('click', function () {
                $('#modalLoi25').hide();
                setCookie('law25_modal_shown', '1', 1); 
            });

            $('#acceptLoi25').on('click', function () {
                $('#modalLoi25').hide();

                setCookie('law25_modal_shown', '1', 1); 
            });
        }
    });

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    // Function to get the value of a cookie by its name
    function getCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name + '=') === 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return '';
    }
})(jQuery);

